// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ad-trigger":"_1Xk7wA","active":"_3mi3kG","on-background":"_2KxvF_"};